import { render, staticRenderFns } from "./folders-list-links-vessels.vue?vue&type=template&id=ff342b02&scoped=true"
import script from "./folders-list-links-vessels.vue?vue&type=script&lang=js"
export * from "./folders-list-links-vessels.vue?vue&type=script&lang=js"
import style0 from "./folders-list-links-vessels.vue?vue&type=style&index=0&id=ff342b02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff342b02",
  null
  
)

export default component.exports